// extracted by mini-css-extract-plugin
export default {"cls1":"mGAg7xMdeFzWkn5MZKe1","cls2":"y_JczVCESEvW5vgNMPZk mGAg7xMdeFzWkn5MZKe1","isTabletUp":"iFT3D5D181nBBfHENsnI"};